<form [formGroup]="formGroup" [bitSubmit]="submit" class="tw-container">
  <div *ngIf="loggingIn">
    <bit-icon name="bwi-spinner" class="bwi-spin" [ariaLabel]="'loading' | i18n"></bit-icon>
    {{ "loading" | i18n }}
  </div>
  <div *ngIf="!loggingIn">
    <div class="tw-flex tw-gap-2">
      <button
        type="submit"
        bitButton
        bitFormButton
        buttonType="primary"
        [block]="true"
        appAutofocus
      >
        {{ "continue" | i18n }}
      </button>
    </div>
  </div>
</form>
